import BaseItemStudyApp from 'es6/controllers/apps/base-item-study-app';
import IKnowQuizSettingsPanel from 'es6/components/apps/settings/iknow-quiz-settings-panel';
import IKnowSequencer from 'es6/controllers/apps/iknow-sequencer';
import Logger from 'es6/services/logger';
import { t } from 'es6/services/localization';

export default class IKnowApp extends BaseItemStudyApp {

  /**
   * Takes app settings from the app-launcher.
   */
  constructor(appSettings) {
    // Pass to BaseStudyApp for initialization.
    super('item_study', appSettings);
  }

  /**
   * Only iKnow uses the mark as correct prompt/dialogue for
   * the answer screens, override the parent method and
   * instantiate the ModalWindow for the correct dialogue.
   */
  _setupUtilities() {
    super._setupUtilities();

    Smartfm.Apps.Modals.markAsCorrectDialogue = new Smartfm.Apps.Utilities.ModalWindow('mark_as_correct', { window: Smartfm.Apps.Common.Windows.MarkAsCorrect });
    Smartfm.Apps.Modals.markAsCorrectDialogue.addEvent('item_was_marked_as_correct', this._itemMarkedAsCorrect.bind(this));
  }

  /**
   * Set up additional legacy screens that are used by iKnow.
   */
  _setupScreens() {
    super._setupScreens();

    const screenManager = this._screenManager;

    screenManager.addScreen('recall', Smartfm.Apps.iKnow.Screens.Recall);
    screenManager.addScreen('multiple_choice_five', Smartfm.Apps.iKnow.Screens.MultipleChoice);
    screenManager.addScreen('image_multiple_choice_five', Smartfm.Apps.iKnow.Screens.ImageMultipleChoice);
    screenManager.addScreen('fill_in_the_blank', Smartfm.Apps.iKnow.Screens.FillInTheBlank);

    // For skipping an item out of session.
    screenManager.addEvent('skip_item', this._skipItem.bind(this));
  }

  /**
   * Creates the sequencer for iKnow.
   *
   * @returns {IKnowSequencer}
   */
  _createSequencer() {
    return new IKnowSequencer(this._sessionData, this._quizTimer);
  }

  /**
   * Set defaults for the user settings object.
   *
   * @override
   * @returns {Object}
   */
  _getDefaultQuizOptions() {
    return {
      audio: true,
      spelling: true,
    };
  }

  /**
   * Add settings panel that are specific to iKnow.
   *
   * @returns {Array}
   */
  _getSettingsPanels() {
    const panels = super._getSettingsPanels();

    // Add the iKnow quiz settings panel.
    panels.splice(1, 0, IKnowQuizSettingsPanel);

    return panels;
  }

  /**
   * Add study parameters that are specific to iKnow.
   *
   * @returns {Object}
   */
  _getStudyParameters() {
    const params = super._getStudyParameters();
    const quizOptions = this._userSettings.apps.itemStudy.quizOptions;

    if (!quizOptions.audio) {
      params.sequenceOptions.push('no_audio');
    }

    if (!quizOptions.spelling) {
      params.sequenceOptions.push('no_spelling');
    }

    return params;
  }

  /**
   * Callback for marking an item as correct in the sequencer.
   */
  _itemMarkedAsCorrect() {
    if (!this._sequencer || !this._sequencer.activeQuiz) { // TODO shouldn't be touching activeQuiz... isn't it private now?
      Logger.error('MarkAsCorrect', 'Cannot mark item as correct outside of a study session.');
      return;
    }

    this._sequencer.activeQuiz.quizMarkedAsCorrect(); // TODO change the interface for this
  }

  /**
   * @override
   * @returns {String}
   */
  _getStartButtonLabel() {
    return t('memory-bank-screen.start-item-study');
  }
}
